import PropTypes from 'prop-types'
import React from 'react'
import './styles.scss'
import FontAwesome from 'react-fontawesome'

export class IconButton extends React.Component {
  constructor (props) {
    super(props)
    this.handleClick = this.handleClick.bind(this)
  }

  handleClick (event) {
    const { onClick } = this.props
    event.preventDefault()
    onClick()
  }

  classNameSelector () {
    const { fontAwesomeIcon } = this.props
    if (fontAwesomeIcon.includes('star')) {
      return 'nh-star'
    }
    return ''
  }

  render () {
    const { fontAwesomeIcon, ...rest } = this.props

    return (
      <FontAwesome
        name={fontAwesomeIcon}
        className={`nh-icon-button ${this.classNameSelector()}`}
        size='lg'
        onClick={this.handleClick}
        {...rest}
      />
    )
  }
}

IconButton.propTypes = {

  onClick: PropTypes.any.isRequired,
  fontAwesomeIcon: PropTypes.string.isRequired
}
